// important - has to use LOAD - as shogun seems to add in code after dom loaded
// removeVariantFromHref : wrap an element you wish to scan with a div with a class of : strip-variant-id, strips out ?variant=8437658473 from urls :  andy@blink 02/05/23

window.addEventListener('load', () => {
  removeVariantFromHref();
  
  try {
    updateSchemaType();
  } catch (error) {
  }
  
});


function removeVariantFromHref() {
  try {
    const stripVariantIdDiv = document.querySelector('.strip-variant-id');
    const hrefTags = stripVariantIdDiv.querySelectorAll('a[href*="?variant="]');
    hrefTags.forEach((hrefTag) => {
      const url = new URL(hrefTag.href);
      const variantParam = url.searchParams.get('variant');
      if (variantParam) {
        const newUrl = url.pathname;
        hrefTag.href = newUrl;
      }
    });
  } catch (error) {
    // Handle the error here, or simply ignore it if you don't need to take any specific action
  }
}







function alter_menu() {

  let { textContent: strippedRoute } = document.querySelector('.route');

  // Remove the slash if the root url is empty
  if (strippedRoute === '/') {
    strippedRoute = '';
  }

  if (strippedRoute === '') {
    alter_menu_action();
  }

}




